import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";

const SubmissionsList = ({ submissions, onSubmissionSelect }) => {
  if (submissions?.length === 0) {
    return <Typography>No current open submissions</Typography>;
  }
  return (
    <>
      <List sx={{ width: "100%", marginTop: 4 }}>
        {submissions?.map((x) => (
          <ListItem
            key={x.id}
            disableGutters
            sx={{ backgroundColor: (theme) => theme.palette.pure.white }}
          >
            <ListItemButton onClick={() => onSubmissionSelect(x)}>
              <ListItemText
                primary={x.existingMasterProductId === null ? x.newMasterProductEntry?.name : x.existingSpecMasterProduct?.name}
                sx={{ marginLeft: 4 }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default SubmissionsList;
